import { Button, SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement, forwardRef, useLayoutEffect, useRef, useState } from 'react';
import useFetchSnippet from '../../../hooks/snippets/useFetchSnippet';
import { SnippetType } from '../../../models';

import styles from './CustomDeal.module.scss';

const cx = classNames.bind(styles);

const CustomDeal = (props: SortableWidgetProps, ref): ReactElement | null => {
  const { data: snippet } = useFetchSnippet(SnippetType.BOILER_PLATE, 'custom_deal_widget');

  const [open, setOpen] = useState(false);
  const [isContentOverflowing, setIsContentOverflowing] = useState(false);

  const contentRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (contentRef.current && contentRef.current.clientHeight < contentRef.current.scrollHeight) {
      setIsContentOverflowing(true);
    }
  }, [contentRef, snippet]);

  if (!snippet) {
    return null;
  }

  return (
    <Widget headerTitle={snippet.title} dataTestId="cs-custom-deal" ref={ref} {...props}>
      <>
        <div className={cx({ collapsed: !open })} dangerouslySetInnerHTML={{ __html: snippet.body }} ref={contentRef} />
        {isContentOverflowing && (
          <Button className={cx('link')} onClick={() => setOpen(!open)}>
            Read {open ? 'Less' : 'More'}
          </Button>
        )}
      </>
    </Widget>
  );
};

export default forwardRef(CustomDeal);
